export default __webpack_public_path__ + "static/media/scanner.d10100cc.png";